<script setup>
import gsap from '~/vendors/gsap'
import SplitType from 'split-type'
import { eyebrowAnimation } from '~~/utils/animations'
import GlobalEmitter from '~~/glxp/utils/emitter'

const props = defineProps({
  tag: {
    type: String,
    default: 'span',
  },
  parentIsRevealed: {
    type: Boolean,
    default: false,
  },
})

const el = ref(null)

const isInView = ref(false)

const isActive = ref(false)
watchEffect(() => {
  if (props.parentIsRevealed && isInView.value) {
    isActive.value = true
  }
  if (!props.parentIsRevealed) {
    isActive.value = false
  }
})

function onEnter() {
  isInView.value = true
}

function onExit() {
  isInView.value = false
}

let timeline
function init() {
  const { chars } = new SplitType(el.value, {
    types: 'chars, words', // split by words as well to prevent weird line breaks
  })
  if (timeline) {
    timeline.progress(1)
    timeline.kill()
  }

  timeline = gsap
    .timeline({ paused: true, clearProps: true })
    .from(chars, eyebrowAnimation)

  timeline.progress(1).progress(0)

  if (isActive.value) {
    timeline.progress(1)
  }
}

watch(isActive, (value) => {
  if (value) {
    timeline.play(0)
  } else {
    timeline?.reverse(timeline.duration())
  }
})

// Lifecycle
onMounted(() => {
  init()
  GlobalEmitter.on('debouncedResize', init)
})

onBeforeUnmount(() => {
  timeline?.kill()
  GlobalEmitter.off('debouncedResize', init)
})
</script>

<template>
  <InView class="text-animation" @enter="onEnter" @exit="onExit">
    <component :is="tag" ref="el">
      <slot />
    </component>
  </InView>
</template>

<style lang="scss">
.text-animation {
  .word {
    white-space: nowrap;
  }
  .char {
    will-change: opacity;
    font-kerning: none;
  }
}
</style>
